import { useEffect, useState } from "react";
import { Image } from "@fluentui/react-components";
import { useStyles } from "./style";
import { useNavigate } from "react-router-dom";
import { authService } from "@/utils/auth/service";

export default function Login() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    Office.onReady((info) => {
      if (info.host !== Office.HostType.Excel) {
        setError("This add-in only works in Excel");
      }
    });
  }, []);

  const handleLogin = async () => {
    try {
      await authService.login();
      navigate("/");
    } catch (err) {
      setError(err instanceof Error ? err.message : "Sign-in failed");
    }
  };

  const styles = useStyles();

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <Image src={"assets/alpha-script-logo.png"} alt="Alpha Script Logo" className={styles.logo} />
        <Image
          id={"loginButton"}
          src={"assets/ms-sign-in.png"}
          alt="Sign in with Microsoft"
          onClick={handleLogin}
          className={styles.buttonSignin}
        />
      </div>
    </div>
  );
}